import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { GlobalSearchService } from '../../../services/globalsearchservice.service'
import { PrintService } from '../../../services/print.service'
import { UntypedFormControl } from '@angular/forms';
import { filter } from 'rxjs-compat/operator/filter';
@Component({
	selector: 'app-customer-disabled',
	templateUrl: './customer-disabled.component.html',
	styleUrls: ['./customer-disabled.component.scss']
})
export class CustomerDisabledComponent implements OnInit, AfterViewInit {
	@Input() data: any = [];
	filename = 'disabled_customers';
	sending = false;

	search = new UntypedFormControl('');
	alldata: any = false;
	filtereddata: any = false;

	constructor(private globalSearchService: GlobalSearchService, private printService: PrintService) {}
	@ViewChild('print_table') printtable: ElementRef;
	ngOnInit(): void {}

	ngAfterViewInit(): void {
		this.search.valueChanges.subscribe((input)=>{
			this.filterdata(input);
		})
		this.alldata = this.data;
		this.filtereddata = this.alldata;
	}

	filterdata(search){
		if(search == ''){
			this.filtereddata = [...this.alldata];
			return;
		}

		if (search.length) {
    		const searches = search.split(' ');
			
    		searches.forEach(search_val => {
    			this.filtereddata = [...this.alldata].filter((i) => { return ((i.address1 + '^^' + i.address2 + '^^' + i.address3 + '^^' + i.address4 + '^^' + i.address5 + '^^' + i.address6 + '^^' + i.debtorno + '^^' + i.name + '^^' + i.invoiceemailaddress).toUpperCase()).includes(search_val.toUpperCase()) })
    		});
    	}
	}

	export () {
		this.globalSearchService.exportJsonToExcel(this.data, 'DisabledCustomers');
	}

	exportPdf() {
		this.sending = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Customers Out Of Buisness',
			subtitle: 'Created '+today.toLocaleString()
		}

		this.printService.pdf(data).subscribe( (result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.sending = false;

		});
	}
	exportXls() {
		this.sending = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Customers Out Of Buisness',
			subtitle: 'Created '+today.toLocaleString()
		}

		this.printService.xls(data).subscribe( (result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.sending = false;
		});
	}
}